import { Component, OnInit, Inject } from '@angular/core';
import { FilterUtilService } from '@app/shared/services/filter-util.service';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.css']
})
export class BlogsComponent implements OnInit {
  userRole;
  loggedInStatus;
  constructor(
    public filterUtilService: FilterUtilService,
    private authenticationService: AuthenticationService,
    public router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('outer-page');
    // window.scroll(0, 0);
  }

  ngOnInit() {

    this.isLoggedIn();
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  featureUnderConstructionNavigation() {
    if (this.loggedInStatus) {
      this.router.navigate([`${this.userRole}/under-construction`]);
    } else {
      this.router.navigate([`under-construction`]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/blogs/blogs.component.ts